export default __webpack_public_path__ + "static/media/The Many.aabe88af.png";